<template>
    <div class="special-list-section">
        <!-- 16专题 -->
        <van-row
            class="special-list-section-box"
            @click="goDetail(dataItem)"
        >
            <div class="special-list-section-left">
                <van-image
                    fit="cover"
                    class="special-list-section-left-img"
                    :src="dataItem.content.cover_img"
                    width="100%"
                    height="100%"
                />
                <div class="special-list-section-left-top" v-if="dataItem.top == 1">
                    <img src="/static/bytx/tag_top.svg" alt="" />
                </div>
                <div class="special-list-section-left-zl" v-else>
                    {{ dataItem.type_text }}
                </div>
            </div>
            <div class="special-list-section-right">
                <div class="special-list-section-right-title">
                    {{ dataItem.content.title | omitTitle }}
                </div>
                <div class="special-list-section-right-detail">
                    <div>
                        <!-- {{ dataItem.content.created_at }}-->
                        <span>{{ dataItem.content.view_count }}人阅读</span>
                    </div>
                </div>
            </div>
            <div class="clear"></div>
        </van-row>
    </div>
</template>

<script>
import mixins from './mixin'
import Interface from '@/util/interface'
export default {
    mixins: [mixins],
    props: {
        dataItem: {
            type: Object,
            required: true
        },
        contentType: {
          type: Number,
          default: 0
        },
        searchText: {
          type: String,
          default: ''
        }
    },
    methods: {
      goDetail(dataItem) {
        this.$router.push({ name: 'topic-detail', params: { id: dataItem.content.id } })
        Interface.getData('get', `/course-phase/api/recommend_v2/${dataItem.id}/view`)
        Interface.mFootPrint(dataItem.id,67,this.contentType,1,0,0,0,dataItem.content.title, this.searchText)
      }
    }
}
</script>

<style lang="scss" scoped>
.special-list-section {
    border-bottom: 1px solid #f2f2f2;
    padding: 10px 12px;
    background-color: #ffffff;
    margin: 10px 10px;
    border-radius: 10px;

    .special-list-section-top {
        border-radius: 6px;
        position: relative;

        .top-tag {
            top: 0;
            left: 0;
            position: absolute;
        }

        .special-list-section-title-box {
            .special-list-section-title {
                font-family: PingFangSC-Semibold;
                font-size: 16px;
                color: #ffffff;
                letter-spacing: 0;
                margin: 3px 15px;
            }

            .special-list-section-info {
                font-family: Helvetica;
                font-size: 13px;
                color: #ffffff;
                letter-spacing: 0;
                margin-left: 15px;
                float: left;
                margin-bottom: 12px;
                margin-top: 12px;
            }

            .special-list-section-icon {
                float: right;
                margin-right: 15px;
                margin-bottom: 12px;
            }

            box-sizing: border-box;
            position: absolute;
            bottom: 0px;
            width: 100%;
            background-image: linear-gradient(180deg, rgba(51, 51, 51, 0) 0%, rgba(0, 0, 0, 0.4) 99%);
            border-radius: 0 0 6px 6px;
        }

        .special-list-section-desc {
            font-family: PingFangSC-Semibold;
            font-size: 14px;
            color: #ffffff;
            letter-spacing: 0.5px;
            line-height: 24px;
            position: absolute;
            padding: 0 6px;
            bottom: 0px;
            left: 15px;
            font-weight: 500;
            margin-bottom: 10px;
            .light {
                color: #0fb7ad;
            }
        }

        .special-list-section-box {
            padding: 0;
            height: 188px;
            width: 100%;
        }
    }

    &-box {
        width: 345px;
        // padding: 18px 0;
        // border-bottom: 1px solid #f2f2f2;
    }

    &-left {
        width: 130px;
        height: 73px;
        float: left;
        position: relative;
        border-radius: 6px;
        &-img {
            width: 112px;
            height: 66px;
            //background: #EFF3FA;
            border-radius: 6px;
            >>> .van-image__img,
            img {
                border-radius: 6px;
            }
        }
        &-zl {
            position: absolute;
            top: 0;
            left: 0;
            background: #10c3b5;
            border-radius: 6px 3px 3px 3px;
            font-family: PingFangSC-Medium;
            font-size: 10px;
            color: #ffffff;
            letter-spacing: 0;
            padding: 1px 6px;
            &.active {
                background-image: linear-gradient(135deg, #ffa3af 0%, #ff555e 100%);
                border-radius: 6px 3px 3px 3px;
            }
            img {
                width: 32px;
                height: 18px;
            }
        }
    }

    &-right {
        float: left;
        margin-left: 14px;
        width: 193px;
        text-align: left;

        &-time {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #0fb7ad;
            letter-spacing: 0;

            background: #e6fdf6;
            border-radius: 4px;
            display: inline-block;
            padding: 2px 6px;
        }

        &-title {
            font-family: PingFangSC-Medium;
            font-size: 15px;
            color: #222222;
            letter-spacing: 0;
            font-weight: 500;
            .light {
                color: #0fb7ad;
            }
        }

        &-detail {
            margin-top: 14px;
            width: 100%;
            font-size: 12px;
            color: #979799;
            div {
                display: inline-block;
            }
        }

        .special-list-section-info {
            margin-top: 8px;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #9a9a9a;
            letter-spacing: 0;
        }
    }

    .special-list-section {
        padding-bottom: 0px;
        .special-list-section-box {
            border-bottom-width: 0px;
            padding-bottom: 0px;
            .special-list-section-left-img {
                width: 130px;
                height: 73px;
            }
            .special-list-section-left-top {
                position: absolute;
                top: 4px;
                left: 4px;
                width: 18px;
                height: 18px;
                border-radius: 3px;
                img {
                    width: 18px;
                    height: 18px;
                    border-radius: 3px;
                }
            }
            .special-list-section-right-detail {
                span {
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #9d9d9d;
                    line-height: 17px;
                }
            }
        }
    }

    .special-list-section-left-zl {
        position: absolute;
        top: 4px;
        left: 4px;
        background: linear-gradient(90deg, rgba(87, 80, 94, 0.9) 0%, rgba(43, 41, 45, 0.9) 100%);
        background: linear-gradient(90deg, #faedd4 0%, #f0dbb6 100%);
        border-radius: 4px;
        font-size: 11px;
        font-family: HarmonyOS_Sans_SC_Bold;
        color: #976730;
        line-height: 16px;
        padding: 1px 1.6vw;
    }
    .special-list-section-left-top {
        position: absolute;
        top: 4px;
        left: 2px;
        width: 18px;
        height: 18px;
        border-radius: 3px;
        img {
            width: 18px;
            height: 18px;
            border-radius: 3px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/contentSelection/modules/special.vue